import React from 'react';
import type { LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void; icon?: LucideIcon };
  variant?: 'default' | 'dashed';
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  description,
  action,
  variant = 'default',
}) => {
  const ActionIcon = action?.icon;

  if (variant === 'dashed') {
    return (
      <div className="py-32 text-center space-y-6 bg-white/40 rounded-[64px] border-4 border-dashed border-pt-forest/5 animate-in fade-in duration-1000">
        <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center mx-auto shadow-sm">
          <Icon className="text-pt-gold-text opacity-30" size={48} />
        </div>
        <div className="space-y-2">
          <p className="text-pt-forest font-serif text-xl font-bold italic">{title}</p>
          {description && (
            <p className="text-[10px] text-pt-sage-text font-black uppercase tracking-[0.3em]">
              {description}
            </p>
          )}
        </div>
        {action && (
          <button
            onClick={action.onClick}
            className="inline-flex items-center gap-3 px-8 py-4 bg-pt-forest text-pt-gold rounded-[24px] font-black text-[10px] uppercase tracking-[0.2em] pt-button shadow-2xl shadow-pt-forest/20 hover:bg-[#122219] transition-all mx-auto"
          >
            {ActionIcon && <ActionIcon size={18} />}
            {action.label}
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="py-24 text-center space-y-6">
      <div className="w-24 h-24 bg-pt-cream rounded-[40px] flex items-center justify-center mx-auto text-pt-sage-text/20">
        <Icon size={56} />
      </div>
      <div className="space-y-2">
        <p className="text-pt-sage-text italic font-serif text-lg">{title}</p>
        {description && (
          <p className="text-[10px] text-pt-sage-text font-black uppercase tracking-[0.3em]">
            {description}
          </p>
        )}
      </div>
      {action && (
        <button
          onClick={action.onClick}
          className="inline-flex items-center gap-3 px-8 py-4 bg-pt-forest text-pt-gold rounded-[24px] font-black text-[10px] uppercase tracking-[0.2em] pt-button shadow-2xl shadow-pt-forest/20 hover:bg-[#122219] transition-all mx-auto"
        >
          {ActionIcon && <ActionIcon size={18} />}
          {action.label}
        </button>
      )}
    </div>
  );
};

export default React.memo(EmptyState);
